import api from "../api/axios";

const normalizeEventId = (value) => {
  const normalized = String(value ?? "").trim();
  return /^\d+$/.test(normalized) ? normalized : "";
};

const getApiOrigin = (origin) => {
  try {
    return new URL(api?.defaults?.baseURL || "/api", origin).origin;
  } catch {
    return origin;
  }
};

export const isInternalEventCheckoutUrl = (
  url,
  eventId,
  origin = typeof window !== "undefined" ? window.location.origin : ""
) => {
  const normalizedEventId = normalizeEventId(eventId);
  if (!url || !normalizedEventId || !origin) return false;

  try {
    const parsed = new URL(url, origin);
    const allowedOrigins = new Set([origin, getApiOrigin(origin)]);
    if (!allowedOrigins.has(parsed.origin)) return false;
    return parsed.pathname.endsWith(`/events/${normalizedEventId}/buy/`);
  } catch {
    return false;
  }
};

export async function prepareEventCheckoutUrl({ directUrl, eventId }) {
  if (typeof window === "undefined") return directUrl;
  const normalizedEventId = normalizeEventId(eventId);
  if (!isInternalEventCheckoutUrl(directUrl, normalizedEventId)) return directUrl;

  const parsed = new URL(directUrl, window.location.origin);
  const params = {};
  parsed.searchParams.forEach((value, key) => {
    if (key !== "response") params[key] = value;
  });
  params.response = "json";

  const { data } = await api.get(`/events/${normalizedEventId}/buy/`, { params });
  const checkoutUrl = String(data?.checkout_url || "").trim();
  if (!/^https?:\/\//i.test(checkoutUrl)) {
    throw new Error("Payment provider did not return a checkout URL.");
  }
  return checkoutUrl;
}
